export default __webpack_public_path__ + "static/media/dot-pending.e5946d45.svg";